import React from 'react';
import {
  Box,
  Stack,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Chip,
  TextField,
  Button,
} from '@mui/material';
import { AntDesign } from '@expo/vector-icons';
import { themeSelector } from '@reduxLocal/selectors/themeSelector';
import { ScrollView } from 'react-native';

const Add = (props: any) => <AntDesign name="plus" {...props} />;

export default function CustomSelectorManager({
  selectors,
  selectedState,
  states,
  targets,
  setState,
  addSelector,
  removeSelector,
}) {
  const [newSelector, setNewSelector] = React.useState('');
const theme = themeSelector();
  const handleAddSelector = () => {
    if (newSelector) {
      addSelector({ name: newSelector });
      setNewSelector('');
    }
  };

  // Corrected: Access the 'id' property directly on the target object.
  const targetStr = targets.map(t => t ? `#${t.id}` : '').join(', ');

  return (
    <Stack spacing={2} sx={{ p: 2 }}>
      {/* State Selector */}
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Typography variant="h6">Selectors</Typography>
        <FormControl size="small" sx={{ minWidth: 150 }}>
          <InputLabel>State</InputLabel>
          <Select
            value={selectedState}
            label="State"
            onChange={(e) => setState(e.target.value)}
          >
            <MenuItem value="">- State -</MenuItem>
            {/* Corrected: Access 'id' and 'name' properties directly */}
            {states.map((state) => (
              <MenuItem key={state.id} value={state.id}>
                {state.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Stack>

      {/* Add New Selector Input */}
      <Stack direction="row" spacing={1}>
        <TextField
          fullWidth
          size="small"
          variant="outlined"
          placeholder="Add new class..."
          value={newSelector}
          onChange={(e) => setNewSelector(e.target.value)}
          onKeyDown={(e) => e.key === 'Enter' && handleAddSelector()}
        />
        <Button
          variant="contained"
          size="small"
          onClick={handleAddSelector}
          disabled={!newSelector}
        >
          <Add />
        </Button>
      </Stack>

      {/* Applied Selectors */}
      <Box
        sx={{
          p: 1,
          minHeight: 45,
          border: '1px solid #ccc',
          borderRadius: 1,
          display: 'flex',
          flexWrap: 'wrap',
          gap: 1,
        }}
      >
        {selectors.length > 0 ? (
          selectors.map((selector) => (
            <Chip
              key={selector.toString()}
              // Corrected: Access 'label' property directly
              label={selector.label}
              onDelete={() => removeSelector(selector)}
              size="small"
            />
          ))
        ) : (
          <Typography variant="caption" sx={{ opacity: 0.7 }}>
            No selectors applied.
          </Typography>
        )}
      </Box>

      {/* Selected Target Info */}
      <Box>
        <Typography variant="body2" sx={{ opacity: 0.7 }}>
          Selected: <Typography component="span" sx={{ fontWeight: 'bold' }}>{targetStr || 'None'}</Typography>
        </Typography>
      </Box>
    </Stack>
  );
}
